
import React, { useState, useEffect } from 'react';
import './liveScore.css';
import img1 from './image 12.png';

const matchData = [
  { id: 1717, name: "Noida Thunders Vs Lucknow Tigers", date: "Aug 07, 2025", startTime: "15:00", endTime: "17:00" },
  { id: 1718, name: "Ayodhya Super Kings Vs Gorakhpur Giants", date: "Aug 07, 2025", startTime: "17:00", endTime: "18:30" },
  { id: 1719, name: "Kashi Warriors Vs Muzaffarnagar Lions", date: "Aug 08, 2025", startTime: "15:00", endTime: "17:00" },
  { id: 1720, name: "Moradabad Bulls Vs Mathura Yodhas", date: "Aug 08, 2025", startTime: "17:00", endTime: "18:30" },
  { id: 1721, name: "Lucknow Tigers Vs Ayodhya Super Kings", date: "Aug 09, 2025", startTime: "15:00", endTime: "17:00" },
  { id: 1722, name: "Kashi Warriors Vs Noida Thunders", date: "Aug 09, 2025", startTime: "17:00", endTime: "18:30" },
  { id: 1723, name: "Mathura Yodhas Vs Gorakhpur Giants", date: "Aug 10, 2025", startTime: "15:00", endTime: "17:00" },
  { id: 1724, name: "Muzaffarnagar Lions Vs Moradabad Bulls", date: "Aug 10, 2025", startTime: "17:00", endTime: "18:30" },
  { id: 1725, name: "Noida Thunders Vs Mathura Yodhas", date: "Aug 11, 2025", startTime: "15:00", endTime: "17:00" },
  { id: 1726, name: "Kashi Warriors Vs Lucknow Tigers", date: "Aug 11, 2025", startTime: "17:00", endTime: "18:30" },
  { id: 1727, name: "Moradabad Bulls Vs Gorakhpur Giants", date: "Aug 12, 2025", startTime: "15:00", endTime: "17:00" },
  { id: 1728, name: "Muzaffarnagar Lions Vs Ayodhya Super Kings", date: "Aug 12, 2025", startTime: "17:00", endTime: "18:30" },
  { id: 1729, name: "Kashi Warriors Vs Moradabad Bulls", date: "Aug 13, 2025", startTime: "15:00", endTime: "17:00" },
  { id: 1730, name: "Lucknow Tigers Vs Mathura Yodhas", date: "Aug 13, 2025", startTime: "17:00", endTime: "18:30" },
  { id: 1731, name: "Noida Thunders Vs Ayodhya Super Kings", date: "Aug 14, 2025", startTime: "15:00", endTime: "17:00" },
  { id: 1732, name: "Muzaffarnagar Lions Vs Gorakhpur Giants", date: "Aug 14, 2025", startTime: "17:00", endTime: "18:30" },
  { id: 1733, name: "Kashi Warriors Vs Mathura Yodhas", date: "Aug 15, 2025", startTime: "15:00", endTime: "17:00" },
  { id: 1734, name: "Moradabad Bulls Vs Ayodhya Super Kings", date: "Aug 15, 2025", startTime: "17:00", endTime: "18:30" },
  { id: 1735, name: "Muzaffarnagar Lions Vs Lucknow Tigers", date: "Aug 16, 2025", startTime: "15:00", endTime: "17:00" },
  { id: 1736, name: "Noida Thunders Vs Gorakhpur Giants", date: "Aug 16, 2025", startTime: "17:00", endTime: "18:30" },
  { id: 1737, name: "Muzaffarnagar Lions Vs Mathura Yodhas", date: "Aug 17, 2025", startTime: "15:00", endTime: "17:00" },
  { id: 1738, name: "Gorakhpur Giants Vs Noida Thunders", date: "Aug 18, 2025", startTime: "15:00", endTime: "17:00" },
  { id: 1739, name: "Mathura Yodhas Vs Gorakhpur Giants", date: "Aug 19, 2025", startTime: "15:00", endTime: "17:00" },
  // { id: 1740, name: "TBA1 Vs TBA2", date: "Aug 20, 2025", startTime: "15:00", endTime: "17:00" },
  { id: 1740, name: "Muzaffarnagar Lions Vs Mathura Yodhas", date: "Aug 21, 2025", startTime: "15:00", endTime: "17:00" },
].map(match => ({
  ...match,
  fullName: `${match.name} ${match.date}`,
  startDateTime: new Date(`${match.date} ${match.startTime}`),
  endDateTime: new Date(`${match.date} ${match.endTime}`)
}));

// Function to format time in 12-hour format
function formatTime12(date) {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 -> 12
  minutes = minutes < 10 ? "0" + minutes : minutes;
  return `${hours}:${minutes} ${ampm}`;
}

export default function MatchCenter() {
  const [currentMatch, setCurrentMatch] = useState(null);
  const [nextMatch, setNextMatch] = useState(null);
  const [iframeHeight, setIframeHeight] = useState("800px");

  useEffect(() => {
    const checkMatches = () => {
      const now = new Date();
      let activeMatch = null;
      let upcomingMatch = null;

      for (let i = 0; i < matchData.length; i++) {
        const match = matchData[i];
        if (now >= match.startDateTime && now < match.endDateTime) {
          activeMatch = { status: "Live", ...match };
          upcomingMatch = matchData[i + 1] ? { status: "Upcoming", ...matchData[i + 1] } : null;
          break;
        }
        if (now < match.startDateTime) {
          activeMatch = i > 0 ? { status: "Completed", ...matchData[i - 1] } : null;
          upcomingMatch = { status: "Upcoming", ...match };
          break;
        }
      }

      if (!activeMatch && !upcomingMatch) {
        activeMatch = { status: "Completed", ...matchData[matchData.length - 1] };
        upcomingMatch = null;
      }

      setCurrentMatch(activeMatch);
      setNextMatch(upcomingMatch);
    };

    checkMatches();
    const interval = setInterval(checkMatches, 60000);

    const handleResize = () => {
      const height = window.innerHeight - 200;
      setIframeHeight(`${Math.max(height, 600)}px`);
    };
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!currentMatch) {
    return <p style={{ textAlign: "center", marginTop: "2rem" }}>No matches available</p>;
  }

  return (
    <div className="scoreboard-container" style={{ width: '100%', maxWidth: '100vw', padding: '1rem' }}>
      <div className="scoreboard-wrapper" style={{ margin: '0 auto' }}>
        
        {/* Current Match */}
        <h2 style={{ textAlign: "center", marginBottom: "0.5rem", color: "#FFCA49", fontSize: "1.8rem", fontWeight: "bold", fontFamily: "poppins" }}>
          {`${currentMatch.status}: ${currentMatch.name} ${currentMatch.date}`}
        </h2>
        
        {/* Next Match */}
        {nextMatch && (
          <h3 style={{ textAlign: "center", marginBottom: "1rem", color: "#fff", fontSize: "1.2rem", fontFamily: "poppins" }}>
            {`${nextMatch.status}: ${nextMatch.name} ${nextMatch.date} at ${formatTime12(nextMatch.startDateTime)}`}
          </h3>
        )}

        {/* Scoreboard */}
        {currentMatch.status === "Live" || currentMatch.status === "Completed" ? (
          <div style={{ width: '100%', overflow: 'hidden', borderRadius: "12px", backgroundColor: '#f0f0f0' }}>
            <iframe
              src={`https://dz8zbd8amw7pd.cloudfront.net/UPPVL/MatchCenter/index.html?m=${currentMatch.id}`}
              style={{ width: "100%", height: iframeHeight, border: "none", minHeight: "600px" }}
              title="UPPVL Match Center"
            ></iframe>
          </div>
        ) : null}
      </div>
    </div>
  );
}

